<template>

  <el-dialog custom-class="list-dialog" title="查有效期" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="24">
          <el-checkbox-group v-model="checkedPingpai">
            <el-checkbox v-for="item in categoryData" :label="item.id" :key="item.id">{{item.text}}</el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="5">
          <el-date-picker
            v-model="form.begindate" size="mini"
            type="date" :value-format="'yyyy-MM-dd'"
            align="left"  placeholder="开始日期"
            style="width:125px"></el-date-picker>~
            <el-date-picker
              v-model="form.enddate" size="mini"
              type="date" :value-format="'yyyy-MM-dd'"
              align="left"  placeholder="结束日期"
              style="width:125px"
            ></el-date-picker>
        </el-col>
        <el-col :span="3"><el-input v-model="form.certorg" auto-complete="off" size="mini" placeholder="厂家"></el-input></el-col>
        <el-col :span="3"><el-input v-model="form.batchno" auto-complete="off" size="mini" placeholder="批次号"></el-input></el-col>
        <el-col :span="4">
          <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                      :isShowCheckBox="false" :treeWidth="350"
                      :treeHeight="300" :searchText="form.seedname" :inputSize="'mini'"
                      placeholder="请选择商品"
                      @check="checktree">
          </CommonTree>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
        </el-col>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(170)"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="cangkuname" width="100" :show-overflow-tooltip="true"
        label="仓库"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column label="厂家" align="left" header-align="center" width="155" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.certorg }}
        </template>
      </el-table-column>
      <el-table-column label="注册证号" align="left" header-align="center" width="155" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.certno }}
        </template>
      </el-table-column>
      <el-table-column label="球镜" align="left" header-align="center" width="75">
        <template slot-scope="scope">
          {{ getPackagesize(scope.row.packagesize,'Y') }}
        </template>
      </el-table-column>
      <el-table-column label="柱镜" align="left" header-align="center" width="75">
        <template slot-scope="scope">
          {{ getPackagesize(scope.row.packagesize,'X') }}
        </template>
      </el-table-column>
      <el-table-column label="批次号" align="left" header-align="center" width="115" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.batchno }}
        </template>
      </el-table-column>
      <el-table-column label="失效日期" align="left" header-align="center" width="105">
        <template slot-scope="scope">
          {{ scope.row.endtime?(scope.row.endtime.split(' ')[0]):''}}
        </template>
      </el-table-column>
      <el-table-column label="数量" align="right" header-align="center" width="70">
        <template slot-scope="scope">
          {{scope.row.totalnumber == 0 ? "" : scope.row.totalnumber}}
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
  </el-dialog>
</template>

<script>
  import {listBarchnoSub} from '@/api/set/jxcstoregoodsbarcode';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';

  export default {
    name: 'searchEndtimeList',
    data() {
      return {
        msg: '查有效期',
        dialogFormVisible:false,
        searchdatevalue:'',
        checkedPingpai:[],
        form:{seedname:'',seedcode:'',begindate:'',enddate:'',certorg:'',batchno:''},
        categoryData:[],
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: []
      }
    },
    methods: {
      getPackagesize(Packagesize, col) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        return JSON.parse(Packagesize)[col];
      },

      show(categoryData) {
        this.categoryData = [];
        this.checkedPingpai = [];
        for (let i in categoryData) {
          for (let j in categoryData[i].children) {
            for (let m in categoryData[i].children[j].children) {
              var item = categoryData[i].children[j].children[m];
              this.categoryData.push({text: item.text, id: item.id});
            }
          }
        }

        this.dialogFormVisible = true;
        this.bindGrid();
      },
      //商品
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1, categorystarts: '010;006', isyinxin: 'yx', filltemplates: '10;40'})
        })
      },
      //具体商品选择 根据前台数据筛选
      checktree(guids, names, arr) {
        this.form.seedcode = guids;
        this.form.seedname = names
      },
      //绑定分页参数
      bindGrid() {
        listBarchnoSub({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          starttime: this.form.begindate,
          endtime: this.form.enddate,
          seedcode: this.form.seedcode,
          certorglike: this.form.certorg,
          batchnolike: this.form.batchno,
          categorycode: this.checkedPingpai.length > 0 ? this.checkedPingpai.join(';') : ''
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
        });
      },
    },
    mounted() {
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/cert/searchEndtimeList.vue